module.exports = __webpack_public_path__ + "react/sources/images/poppins-v15-latin-700.woff";